import React from "react";
import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, MapPin, Bone, MessageSquareText, Users, KeyRound, LogOut, Download, ExternalLink } from "lucide-react";
import { useAdminAuth, adminApi } from "../../lib/adminAuth";

const links = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "admin-nav-dashboard" },
  { to: "/admin/venues", label: "Locales", icon: MapPin, testid: "admin-nav-venues" },
  { to: "/admin/coupons", label: "Huesos", icon: Bone, testid: "admin-nav-huesos" },
  { to: "/admin/pins", label: "PINs de reclamo", icon: KeyRound, testid: "admin-nav-pins" },
  { to: "/admin/reviews", label: "Reseñas", icon: MessageSquareText, testid: "admin-nav-reviews" },
  { to: "/admin/users", label: "Admins", icon: Users, testid: "admin-nav-users" },
];

export default function AdminLayout() {
  const { admin, loading, logout } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="font-mono text-xs uppercase tracking-widest text-[#A3A3A3]">Cargando…</div>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="admin-panel min-h-screen bg-black text-[#F5F5F5] flex">
      <aside className="w-60 bg-[#0A0A0A] border-r-2 border-[#1A1A1A] flex flex-col" data-testid="admin-sidebar">
        <div className="p-5 border-b-2 border-[#1A1A1A]">
          <div className="font-display text-2xl uppercase tracking-tight">Kiltro</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FEBA01]">Admin Panel</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 font-display uppercase text-sm tracking-wide transition ${
                  isActive ? "bg-[#FEBA01] text-black" : "text-[#A3A3A3] hover:text-[#FEBA01]"
                }`
              }
            >
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
          <a
            href={adminApi.exportClaimsUrl()}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              e.preventDefault();
              const t = localStorage.getItem("kiltro_admin_token");
              fetch(adminApi.exportClaimsUrl(), { headers: { Authorization: `Bearer ${t}` } })
                .then((r) => r.blob())
                .then((blob) => {
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `kiltro_claims_${new Date().toISOString().slice(0, 10)}.csv`;
                  a.click();
                  window.URL.revokeObjectURL(url);
                });
            }}
            className="flex items-center gap-2 px-3 py-2 font-display uppercase text-sm tracking-wide text-[#A3A3A3] hover:text-[#FEBA01] cursor-pointer"
            data-testid="admin-export-csv"
          >
            <Download size={16} /> Export CSV
          </a>
        </nav>
        <div className="p-3 border-t-2 border-[#1A1A1A] space-y-2">
          <Link
            to="/"
            className="flex items-center gap-2 px-3 py-2 font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3] hover:text-[#FEBA01]"
            data-testid="admin-view-site"
          >
            <ExternalLink size={12} /> Ver sitio público
          </Link>
          <div className="px-3 py-1 font-mono text-[10px] text-[#666] truncate" title={admin.email}>
            {admin.email}
          </div>
          <button
            onClick={logout}
            className="w-full flex items-center justify-center gap-2 border-2 border-[#FEBA01] text-[#FEBA01] hover:bg-[#FEBA01] hover:text-black font-display uppercase text-xs tracking-wide py-2 transition"
            data-testid="admin-logout-btn"
          >
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto" data-testid="admin-content">
        <div className="p-6 lg:p-10 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
